/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiVendorsCreateVendorPost } from '../fn/settings-vendors/api-vendors-create-vendor-post';
import { ApiVendorsCreateVendorPost$Params } from '../fn/settings-vendors/api-vendors-create-vendor-post';
import { apiVendorsCreateVendorPost$Plain } from '../fn/settings-vendors/api-vendors-create-vendor-post-plain';
import { ApiVendorsCreateVendorPost$Plain$Params } from '../fn/settings-vendors/api-vendors-create-vendor-post-plain';
import { apiVendorsDeleteVendorDelete } from '../fn/settings-vendors/api-vendors-delete-vendor-delete';
import { ApiVendorsDeleteVendorDelete$Params } from '../fn/settings-vendors/api-vendors-delete-vendor-delete';
import { apiVendorsDeleteVendorDelete$Plain } from '../fn/settings-vendors/api-vendors-delete-vendor-delete-plain';
import { ApiVendorsDeleteVendorDelete$Plain$Params } from '../fn/settings-vendors/api-vendors-delete-vendor-delete-plain';
import { apiVendorsGetVendorPost } from '../fn/settings-vendors/api-vendors-get-vendor-post';
import { ApiVendorsGetVendorPost$Params } from '../fn/settings-vendors/api-vendors-get-vendor-post';
import { apiVendorsGetVendorPost$Plain } from '../fn/settings-vendors/api-vendors-get-vendor-post-plain';
import { ApiVendorsGetVendorPost$Plain$Params } from '../fn/settings-vendors/api-vendors-get-vendor-post-plain';
import { apiVendorsGetVendorsPost } from '../fn/settings-vendors/api-vendors-get-vendors-post';
import { ApiVendorsGetVendorsPost$Params } from '../fn/settings-vendors/api-vendors-get-vendors-post';
import { apiVendorsGetVendorsPost$Plain } from '../fn/settings-vendors/api-vendors-get-vendors-post-plain';
import { ApiVendorsGetVendorsPost$Plain$Params } from '../fn/settings-vendors/api-vendors-get-vendors-post-plain';
import { apiVendorsUpdateVendorPut } from '../fn/settings-vendors/api-vendors-update-vendor-put';
import { ApiVendorsUpdateVendorPut$Params } from '../fn/settings-vendors/api-vendors-update-vendor-put';
import { apiVendorsUpdateVendorPut$Plain } from '../fn/settings-vendors/api-vendors-update-vendor-put-plain';
import { ApiVendorsUpdateVendorPut$Plain$Params } from '../fn/settings-vendors/api-vendors-update-vendor-put-plain';
import { CreateVendorCommandResult } from '../models/create-vendor-command-result';
import { DeleteVendorCommandResult } from '../models/delete-vendor-command-result';
import { GetVendorQueryResult } from '../models/get-vendor-query-result';
import { GetVendorsQueryResult } from '../models/get-vendors-query-result';
import { UpdateVendorCommandResult } from '../models/update-vendor-command-result';

@Injectable({ providedIn: 'root' })
export class SettingsVendorsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiVendorsGetVendorPost()` */
  static readonly ApiVendorsGetVendorPostPath = '/api/Vendors/GetVendor';

  /**
   * Gets a Vendor  based on the provided query.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiVendorsGetVendorPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiVendorsGetVendorPost$Plain$Response(params?: ApiVendorsGetVendorPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetVendorQueryResult>> {
    return apiVendorsGetVendorPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a Vendor  based on the provided query.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiVendorsGetVendorPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiVendorsGetVendorPost$Plain(params?: ApiVendorsGetVendorPost$Plain$Params, context?: HttpContext): Observable<GetVendorQueryResult> {
    return this.apiVendorsGetVendorPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetVendorQueryResult>): GetVendorQueryResult => r.body)
    );
  }

  /**
   * Gets a Vendor  based on the provided query.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiVendorsGetVendorPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiVendorsGetVendorPost$Response(params?: ApiVendorsGetVendorPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetVendorQueryResult>> {
    return apiVendorsGetVendorPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a Vendor  based on the provided query.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiVendorsGetVendorPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiVendorsGetVendorPost(params?: ApiVendorsGetVendorPost$Params, context?: HttpContext): Observable<GetVendorQueryResult> {
    return this.apiVendorsGetVendorPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetVendorQueryResult>): GetVendorQueryResult => r.body)
    );
  }

  /** Path part for operation `apiVendorsGetVendorsPost()` */
  static readonly ApiVendorsGetVendorsPostPath = '/api/Vendors/GetVendors';

  /**
   * Gets a list of Vendor  based on the provided query.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiVendorsGetVendorsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiVendorsGetVendorsPost$Plain$Response(params?: ApiVendorsGetVendorsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetVendorsQueryResult>> {
    return apiVendorsGetVendorsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a list of Vendor  based on the provided query.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiVendorsGetVendorsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiVendorsGetVendorsPost$Plain(params?: ApiVendorsGetVendorsPost$Plain$Params, context?: HttpContext): Observable<GetVendorsQueryResult> {
    return this.apiVendorsGetVendorsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetVendorsQueryResult>): GetVendorsQueryResult => r.body)
    );
  }

  /**
   * Gets a list of Vendor  based on the provided query.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiVendorsGetVendorsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiVendorsGetVendorsPost$Response(params?: ApiVendorsGetVendorsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetVendorsQueryResult>> {
    return apiVendorsGetVendorsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a list of Vendor  based on the provided query.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiVendorsGetVendorsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiVendorsGetVendorsPost(params?: ApiVendorsGetVendorsPost$Params, context?: HttpContext): Observable<GetVendorsQueryResult> {
    return this.apiVendorsGetVendorsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetVendorsQueryResult>): GetVendorsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiVendorsCreateVendorPost()` */
  static readonly ApiVendorsCreateVendorPostPath = '/api/Vendors/CreateVendor';

  /**
   * Creates a new Vendor record.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiVendorsCreateVendorPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiVendorsCreateVendorPost$Plain$Response(params?: ApiVendorsCreateVendorPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateVendorCommandResult>> {
    return apiVendorsCreateVendorPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new Vendor record.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiVendorsCreateVendorPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiVendorsCreateVendorPost$Plain(params?: ApiVendorsCreateVendorPost$Plain$Params, context?: HttpContext): Observable<CreateVendorCommandResult> {
    return this.apiVendorsCreateVendorPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateVendorCommandResult>): CreateVendorCommandResult => r.body)
    );
  }

  /**
   * Creates a new Vendor record.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiVendorsCreateVendorPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiVendorsCreateVendorPost$Response(params?: ApiVendorsCreateVendorPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateVendorCommandResult>> {
    return apiVendorsCreateVendorPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new Vendor record.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiVendorsCreateVendorPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiVendorsCreateVendorPost(params?: ApiVendorsCreateVendorPost$Params, context?: HttpContext): Observable<CreateVendorCommandResult> {
    return this.apiVendorsCreateVendorPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateVendorCommandResult>): CreateVendorCommandResult => r.body)
    );
  }

  /** Path part for operation `apiVendorsUpdateVendorPut()` */
  static readonly ApiVendorsUpdateVendorPutPath = '/api/Vendors/UpdateVendor';

  /**
   * Updates an existing Vendor record.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiVendorsUpdateVendorPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiVendorsUpdateVendorPut$Plain$Response(params?: ApiVendorsUpdateVendorPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateVendorCommandResult>> {
    return apiVendorsUpdateVendorPut$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing Vendor record.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiVendorsUpdateVendorPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiVendorsUpdateVendorPut$Plain(params?: ApiVendorsUpdateVendorPut$Plain$Params, context?: HttpContext): Observable<UpdateVendorCommandResult> {
    return this.apiVendorsUpdateVendorPut$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateVendorCommandResult>): UpdateVendorCommandResult => r.body)
    );
  }

  /**
   * Updates an existing Vendor record.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiVendorsUpdateVendorPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiVendorsUpdateVendorPut$Response(params?: ApiVendorsUpdateVendorPut$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateVendorCommandResult>> {
    return apiVendorsUpdateVendorPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing Vendor record.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiVendorsUpdateVendorPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiVendorsUpdateVendorPut(params?: ApiVendorsUpdateVendorPut$Params, context?: HttpContext): Observable<UpdateVendorCommandResult> {
    return this.apiVendorsUpdateVendorPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateVendorCommandResult>): UpdateVendorCommandResult => r.body)
    );
  }

  /** Path part for operation `apiVendorsDeleteVendorDelete()` */
  static readonly ApiVendorsDeleteVendorDeletePath = '/api/Vendors/DeleteVendor';

  /**
   * Deletes an existing Vendor record.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiVendorsDeleteVendorDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiVendorsDeleteVendorDelete$Plain$Response(params?: ApiVendorsDeleteVendorDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteVendorCommandResult>> {
    return apiVendorsDeleteVendorDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes an existing Vendor record.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiVendorsDeleteVendorDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiVendorsDeleteVendorDelete$Plain(params?: ApiVendorsDeleteVendorDelete$Plain$Params, context?: HttpContext): Observable<DeleteVendorCommandResult> {
    return this.apiVendorsDeleteVendorDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteVendorCommandResult>): DeleteVendorCommandResult => r.body)
    );
  }

  /**
   * Deletes an existing Vendor record.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiVendorsDeleteVendorDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiVendorsDeleteVendorDelete$Response(params?: ApiVendorsDeleteVendorDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteVendorCommandResult>> {
    return apiVendorsDeleteVendorDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes an existing Vendor record.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiVendorsDeleteVendorDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiVendorsDeleteVendorDelete(params?: ApiVendorsDeleteVendorDelete$Params, context?: HttpContext): Observable<DeleteVendorCommandResult> {
    return this.apiVendorsDeleteVendorDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteVendorCommandResult>): DeleteVendorCommandResult => r.body)
    );
  }

}
